























import { Component, Vue, Watch } from 'vue-property-decorator'
import Axios from 'axios'

@Component({})
export default class CompanionAppLogin extends Vue {
  isModalOpen: boolean = false
  loading: boolean = false
  code: string = ''

  openModal() {
    this.loading = false
    this.isModalOpen = true
  }

  async autoLogin() {
    window.location.href = 'rekordcloud://login_' + this.code
  }

  async generateKey() {
    this.loading = true

    const {
      data: { code }
    } = await Axios.get('/user/companion-app-login')

    this.code = code

    this.loading = false
  }

  @Watch('isModalOpen')
  async onModalOpen(v: boolean) {
    if (v) {
      await this.generateKey()
    } else {
      this.code = ''
    }
  }
}
